import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close_circle",
  "use": "close_circle-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"close_circle\"><path d=\"M5 0a5 5 0 10.001 10.001A5 5 0 005 0zm2.03 5.97a.75.75 0 01-1.06 1.061L5 6.061l-.97.97a.748.748 0 01-1.06 0 .75.75 0 010-1.061L3.94 5l-.97-.97a.75.75 0 111.061-1.061l.97.97.97-.97A.75.75 0 117.032 4.03l-.97.97.968.97z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol